<template>
  <div class="white-container full-page-container quickFilterConfiguration">
    <el-form ref="form" size="small">
      <div class="class-item">
        <span class="title">课程</span>
        <div class="select-content">
          <div class="content">
            <span>已添加标签</span>
            <div>
              <span v-for="item in courseSelectedTags" :key="item.id">
                {{ item.tagName }}<i class="el-icon-close close-icon" @click="remove(item, courseType)" />
              </span>
            </div>
          </div>
          <div class="flex-content">
            <el-form-item label="标签维度" style="width:371px;" label-width="71px">
              <el-select v-model="courseTagIndex" placeholder="请选择内容" style="width:280px;">
                <el-option v-for="(item, index) in courseTags" :key="item.categoryId" :label="item.categoryName" :value="index" />
              </el-select>
            </el-form-item>
            <el-form-item v-if="courseTags[courseTagIndex]" label="标签项" style="width:371px; margin-left:32px">
              <DragSelect v-model="courseTags[courseTagIndex].selectIds" multiple placeholder="请选择内容" style="width:280px;" @change="handleCourseTagChange">
                <el-option v-for="item in courseTags[courseTagIndex] && courseTags[courseTagIndex].children" :key="item.id" :label="item.tagName" :value="item.id" />
              </DragSelect>
            </el-form-item>
          </div>
        </div>
        <div class="flex btns">
          <el-button type="info" class="reset" @click="reset(courseType)">重置</el-button>
          <el-button type="primary" :disabled="courseOperation" @click="submit(courseType)">保存</el-button>
        </div>
      </div>
      <div class="activity-item">
        <span class="title">活动</span>
        <div class="select-content">
          <div class="content">
            <span>已添加标签</span>
            <div>
              <span v-for="item in activitySelectedTags" :key="item.id">{{ item.name }}<i class="el-icon-close close-icon" @click="remove(item, activityType)" /></span>
            </div>
          </div>
          <div class="flex-content">
            <el-form-item label="标签项" label-width="71px" style="width:371px">
              <DragSelect v-model="activityTagsSelectId" style="width:280px;" multiple placeholder="请选择标签项" @change="handleActivityTagChange">
                <el-option v-for="item in activityTags" :key="item.id" :label="item.name" :value="item.id" />
              </DragSelect>
            </el-form-item>
          </div>
        </div>
        <div class="flex btns">
          <el-button type="info" class="reset" @click="reset(activityType)">重置</el-button>
          <el-button type="primary" :disabled="activityOperation" @click="submit(activityType)">保存</el-button>
        </div>
      </div>
    </el-form>
    <Dialog v-if="formDialogShow" v-model="formDialogShow" :information="information" @submit-success="dialogSuccess" />
  </div>
</template>
<script>
import DragSelect from '@/components/DragSelect';
import Dialog from "@/components/Dialog";
export default {
  components: { DragSelect, Dialog },
  data() {
    return {
      courseTags: [], // 课程标签数据
      courseTagIndex: null, // 课程标签维度下标
      courseSelectedTags: [], // 课程下拉选中标签项
      activityTags: [], // 活动标签数据
      activityTagsSelectId: [], // 活动标签选中id
      activitySelectedTags: [], // 活动下拉选中标签项
      courseType: 'course',
      activityType: 'activity',
      courseOperation: true, // 未操作状态
      activityOperation: true, // 未操作状态
      formDialogShow: false,
    };
  },
  computed: {},
  async created() {
    try {
      const [courseTagsRes, activityTagsRes, addTagListRes] = await Promise.all([
        this.$Api.quickFilterConfiguration.getQuickScreeningCourseTags(),
        this.$Api.activity.getActivityTag(),
        this.$Api.quickFilterConfiguration.getQuickScreeningList(),
      ]);

      this.courseTags = courseTagsRes.map(item => {
        item.selectIds = [];
        return item;
      });
      this.activityTags = activityTagsRes;

      // 更新选定标签
      this.updateSelectedTags(addTagListRes);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  },
  methods: {
    updateSelectedTags(res) {
      // 更新课程标签
      if (res.courseTags && res.courseTags.length) {
        this.courseSelectedTags = res.courseTags;
        this.updateCourseTagsSelectIds(this.courseSelectedTags);
      }

      // 更新活动标签
      if (res.activityTags && res.activityTags.length) {
        this.activitySelectedTags = res.activityTags;
        this.updateActivityTagsSelectIds(this.activitySelectedTags);
      }
    },
    /** 回显课程标签 */
    updateCourseTagsSelectIds(selectedTags) {
      selectedTags = selectedTags.map((tag) => {
        const dimensionIndex = this.courseTags.findIndex(category => category.children.some(child => child.id === tag.id));
        const matchingCategory = this.courseTags.find(category => category.children.some(child => child.id === tag.id));
        if (matchingCategory) {
          matchingCategory.selectIds.push(tag.id);
        }
        tag.dimensionIndex = dimensionIndex;
        return tag;
      });

      if (this.courseTags[this.courseTagIndex]) {
        this.courseTags[this.courseTagIndex].selectIds = this.courseTags[this.courseTagIndex].selectIds.filter(id =>
          this.courseSelectedTags.some(selectedTag => selectedTag.id === id)
        );
      }
    },
    /** 回显活动标签 */
    updateActivityTagsSelectIds(selectedTags) {
      selectedTags.forEach(tag => {
        if (this.activityTags.some(activityTag => activityTag.id === tag.id)) {
          this.activityTagsSelectId.push(tag.id);
        }
      });
    },
    /** 切换课程标签项 */
    handleCourseTagChange(newSelectedIds) {
      this.handleCourseOperation();
      const currentDimensionSelectedTags = this.courseSelectedTags.filter(tag => tag.dimensionIndex === this.courseTagIndex);

      const tagsToRemove = [];

      currentDimensionSelectedTags.forEach(tag => {
        if (!newSelectedIds.includes(tag.id)) {
          tagsToRemove.push(tag.id);
        }
      });

      tagsToRemove.forEach(id => {
        this.courseSelectedTags = this.courseSelectedTags.filter(tag => tag.id !== id || tag.dimensionIndex !== this.courseTagIndex); this.courseSelectedTags = this.courseSelectedTags.filter(tag => tag.id !== id || tag.dimensionIndex !== this.courseTagIndex);
      });

      newSelectedIds.forEach(id => {
        const tagItem = this.courseTags[this.courseTagIndex]?.children?.find(child => child.id === id);
        if (tagItem && !currentDimensionSelectedTags.some(selectedTag => selectedTag.id === id)) {
          this.courseSelectedTags.push({
            tagName: tagItem.tagName,
            id: tagItem.id,
            categoryId: tagItem.categoryId,
            dimensionIndex: this.courseTagIndex, // 记录标签来自哪个维度
          });
        }
      });
    },
    /** 切换活动标签项 */
    handleActivityTagChange(newSelectedIds) {
      this.handleActivityOperation();
      newSelectedIds.forEach(id => {
        const tagItem = this.activityTags.find(child => child.id === id);
        if (tagItem && !this.activitySelectedTags.some(selectedTag => selectedTag.id === id)) {
          this.activitySelectedTags.push({
            name: tagItem.name,
            id: tagItem.id,
          });
        }
      });
      this.activitySelectedTags = this.activitySelectedTags.filter(tag => newSelectedIds.includes(tag.id));
    },
    /** 删除已添加标签 */
    remove(item, type) {
      if (type === this.courseType) {
        this.handleCourseOperation();
        this.courseSelectedTags = this.courseSelectedTags.filter(tag => tag.id !== item.id);
        this.courseTags[item.dimensionIndex].selectIds = this.courseTags[item.dimensionIndex].selectIds.filter(id => id !== item.id);
      } else if (type === this.activityType) {
        this.handleActivityOperation();
        this.activitySelectedTags = this.activitySelectedTags.filter(tag => tag.id !== item.id);
        this.activityTagsSelectId = this.activityTagsSelectId.filter(id => id !== item.id);
      }
    },
    /** 重置 */
    reset(type) {
      if (type === this.courseType) {
        this.handleCourseOperation();
        this.courseSelectedTags = [];
        this.courseTagIndex = null;
        this.courseTags = this.courseTags.map(item => {
          item.selectIds = [];
          return item;
        });
      } else if (type === this.activityType) {
        this.handleActivityOperation();
        this.activitySelectedTags = [];
        this.activityTagsSelectId = [];
      }
    },
    /** 提交 */
    submit(type) {
      this.formDialogShow = true;
      this.information = {
        operation: `submit`,
        type,
        icon: "warn",
        subTitle: "保存后，课程快速筛选将在前端显示",
      };
    },
    /** 弹窗回调 */
    dialogSuccess() {
      const information = this.information;
      if (information && information.operation === 'submit' && information.type === this.courseType) {
        this.$Api.quickFilterConfiguration.getQuickScreeningSaveCourse({ courseTags: this.courseSelectedTags })
          .then(() => {
            this.$message.success(`保存成功`);
            this.courseOperation = true;
          })
          .catch(err => {
            this.$message.error(err.errorMessage || `保存失败`);
          });
      } else if (information && information.operation === 'submit' && information.type === this.activityType) {
        this.$Api.quickFilterConfiguration.getQuickScreeningSaveActivity({ activityTags: this.activitySelectedTags })
          .then(() => {
            this.$message.success(`保存成功`);
            this.activityOperation = true;
          })
          .catch(err => {
            this.$message.error(err.errorMessage || `保存失败`);
          });
      }
    },
    /** 课程栏未操作状态控制 */
    handleCourseOperation() {
      if (!this.courseOperation) return;
      this.courseOperation = false;
    },
    /** 活动栏未操作状态控制 */
    handleActivityOperation() {
      if (!this.activityOperation) return;
      this.activityOperation = false;
    },
  },
};
</script>
<style lang="less" scoped>
.quickFilterConfiguration {
  position: relative;
  .class-item,
  .activity-item {
    box-sizing: border-box;
    padding: 20px;
    margin-bottom: 30px;
    width: 100%;
    min-height: 199px;
    background: rgba(247, 247, 247, 1);
    display: flex;
    flex-direction: column;
    > .title {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 30px;
    }
    > .select-content {
      width: 100%;
      min-height: 106px;
      > .content {
        box-sizing: border-box;
        width: 100%;
        min-height: 64px;
        margin-bottom: 10px;
        > span {
          display: inline-block;
          line-height: 20px;
          font-size: 14px;
          font-weight: 400;
          margin-bottom: 10px;
        }
        > div {
          display: flex;
          align-items: center;
          flex-wrap: wrap;
          > span {
            box-sizing: border-box;
            display: flex;
            align-items: center;
            background: #e7e7e7;
            height: 24px;
            padding: 2px 8px;
            font-size: 12px;
            margin-right: 10px;
            margin-bottom: 10px;
            line-height: 20px;
            i {
              font-size: 14px;
              margin-left: 8px;
              cursor: pointer;
              user-select: none;
            }
            &:last-child {
              margin-right: 0px;
            }
          }
        }
      }
      > .flex-content {
        display: flex;
        /deep/.el-input__inner {
          height: 34px;
        }
      }
    }

    .btns {
      margin-top: 60px;
      justify-content: center;
      .el-button {
        width: 120px;
        height: 50px;
        &.is-disabled {
          background: #bbbbbb;
          border: none;
        }
      }

      .reset {
        background: #bbbbbb;
        border: none;
      }
    }
  }
}
</style>
